/* eslint-disable camelcase */
import ReduxService from '../../../redux/redux.service';
import { ReduxState } from 'src/redux/redux-state';
import { invisiblyApi } from '../../../redux/api/invisibly-api';
import { APITagType } from '../../../redux/api/invisibly-api.types';
import { InvisiblyApiResponse } from '../../../services/api/api-response.types';
import { AggregateDataApiResponse, GetPerformanceDataParams, TimeSeriesDataApiResponse } from '../types/performance.types';

const getIsClientView = (): boolean => {
  const state = ReduxService.Store.getState() as ReduxState;
  const userGroups = state?.userState?.permissions?.groups || [];
  return userGroups.includes('client_user') || userGroups.includes('client_admin');
};

const getApiPrefix = () => {
  const isClient = getIsClientView();
  return isClient ? 'client' : 'b2b';
};

const overviewEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    getOverviewAggregateData: builder.query<AggregateDataApiResponse, GetPerformanceDataParams>({
      query: ({ start_date, end_date, filter, extClientId }) => {
        const prefix = getApiPrefix();
        return {
          method: 'GET',
          url: `${prefix}/performance/aggregate`,
          params: {
            start_date,
            end_date,
            filter,
            ext_client_id: extClientId,
          },
        };
      },
      transformResponse(response: InvisiblyApiResponse<AggregateDataApiResponse>) {
        return response.item;
      },
      providesTags: [{ type: APITagType.PerformanceOverview, id: 'LIST' }],
    }),
    getOverviewTimeSeriesData: builder.query<TimeSeriesDataApiResponse, GetPerformanceDataParams>({
      query: ({ start_date, end_date, filter, extClientId }) => {
        const prefix = getApiPrefix();
        return {
          method: 'GET',
          url: `${prefix}/performance/time_series`,
          params: {
            start_date,
            end_date,
            filter,
            ext_client_id: extClientId,
          },
        };
      },
      transformResponse(response: InvisiblyApiResponse<TimeSeriesDataApiResponse>) {
        return response.item;
      },
      providesTags: [{ type: APITagType.PerformanceOverview, id: 'LIST' }],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetOverviewAggregateDataQuery,
  useGetOverviewTimeSeriesDataQuery,
} = overviewEndpoints;